"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _class, _class2, _class3, _temp, _class4, _class5, _temp2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Height = 5;

var SwingingBarIndicator = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SwingingBarIndicator, _Component);

  var _super = _createSuper(SwingingBarIndicator);

  function SwingingBarIndicator() {
    var _this;

    (0, _classCallCheck2["default"])(this, SwingingBarIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(SwingingBarIndicator, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className),
        style: {
          height: Height
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.line)
      }));
    }
  }, {
    key: "styles",
    get: function get() {
      var color = this.props.color;
      var primaryLight = this.context.theming.theme.primaryLight;
      var keyframes = {
        "0%": {
          width: 0,
          opacity: 0,
          marginLeft: 0
        },
        "50%": {
          width: "50%"
        },
        "100%": {
          width: 0,
          opacity: 1,
          marginLeft: "100%"
        }
      };
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          minWidth: 200,
          alignItems: "stretch",
          flexDirection: "row",
          borderRadius: Height,
          height: Height,
          backgroundColor: primaryLight
        },
        line: {
          borderRadius: Height,
          backgroundColor: color,
          animationName: [keyframes],
          animationDuration: "1300ms",
          animationDirection: "alternate",
          animationIterationCount: "infinite"
        }
      });
    }
  }]);
  return SwingingBarIndicator;
}(_react.Component), _class3.contextType = _providers.LegoContext, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var LoadingIndicator = (0, _mobxReact.observer)(_class4 = (_temp2 = _class5 = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(LoadingIndicator, _Component2);

  var _super2 = _createSuper(LoadingIndicator);

  function LoadingIndicator() {
    var _this2;

    (0, _classCallCheck2["default"])(this, LoadingIndicator);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.context = void 0;
    return _this2;
  }

  (0, _createClass2["default"])(LoadingIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          color = _this$props.color,
          loadingComplete = _this$props.loadingComplete,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          size = _this$props.size;
      var primary = this.context.theming.theme.primary;

      if (loadingComplete) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
      }

      if (type == "spinner") {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
          className: (0, _styling.css)(className, style),
          size: size
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(className, style),
        style: _objectSpread({
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 40
        }, style)
      }, /*#__PURE__*/_react["default"].createElement(SwingingBarIndicator, {
        color: color || primary
      }));
    }
  }]);
  return LoadingIndicator;
}(_react.Component), _class5.contextType = _providers.LegoContext, _class5.propDoc = {
  type: {
    required: false,
    defaultValue: "swinging-bar",
    type: "\"spinner\" | \"swinging-bar\"",
    description: "Type of loading indicator to display"
  },
  size: {
    required: false,
    defaultValue: "30",
    type: "number",
    description: "Optional size of the loading indicator. " + "Only used when `type=\"spinner\"`"
  },
  color: {
    required: false,
    defaultValue: _providers.DefaultThemingContext.theme.corePrimary,
    type: "number",
    description: "Color of the loading indicator"
  },
  loadingComplete: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "`LoadingIndicator` can be used as a container, " + "to hide content that needs to be gated until loading is " + "complete. Example is `<LoadingIndicator>hide me while " + "loading</LoadingIndicator>` \n\n" + "In this scenario, set `loadingComplete` to `true` when the " + "loading is complete to display the children."
  }
}, _class5.defaultProps = {
  type: "swinging-bar"
}, _class5.demoProps = [{
  type: "swinging-bar",
  demoDescription: "swinging bar"
}, {
  type: "spinner",
  size: 70,
  demoDescription: "spinner"
}], _temp2)) || _class4;

var _default = LoadingIndicator;
exports["default"] = _default;